export const isProd = true;
export const BASE_URL_WITHOUT_SLASH = "https://online.honda.com.tr";
export const WEB_SERVICE_URL = isProd === true ? (typeof window !== "undefined" ? "/backend/" : `${BASE_URL_WITHOUT_SLASH}/backend/`) : "/backend/";
export const ASSETS = "/assets"
export const DMS_WEB_SERVICE_URL=isProd ? "https://honda.dealercom.net/api/rest/v1/":"https://honda.dealercom.net/api/rest/v1/";
export const PAYZEE_WEB_SERVICE_URL="https://ppgpayment.birlesikodeme.com";
export const PAYZEE_SUCCESS_URL="https://online.honda.com.tr/backend/paymentSuccess";
export const PAYZEE_FAIL_URL="https://online.honda.com.tr/backend/paymentFailed";
export const PAYZEE_MERCHANTID = 7226;